import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  makeStyles,
  Snackbar,
} from "@material-ui/core";
import { UserDataContext } from "../../Contexts/UserDataContext";
import clsx from "clsx";
import Axios from "axios";
import { SelectUserIdInputComponent } from "./InputComponents";

const useStyles = makeStyles((theme) => ({
  filter: {
    width: "240px",
  },
  root: {
    width: "360px",
  },
  spacer: {
    flexGrow: 1,
  },
}));

const ResetPasswordCard = ({ className, ...rest }) => {
  const { userData } = useContext(UserDataContext);
  const [userId, setUserId] = useState(undefined);
  const [snackOpen, setSnackOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();
  const [key, setKey] = useState(0);

  const resetPassword = async () => {
    const request = {
      method: "POST",
      url: `/users/resetPassword/${userId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    try {
      setLoading(true);
      await Axios(request);
      setSnackOpen(true);
      setUserId(undefined);
      setKey(key + 1);
    } catch (error) {
      console.log(error);
      console.log(JSON.stringify(error.response.data.errors));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={snackOpen}
        autoHideDuration={6000}
        onClose={() => setSnackOpen(false)}
        message="Password successfully reset."
      />

      <CardHeader title="Reset a user's password" />
      <Divider />
      <CardContent>
        <SelectUserIdInputComponent
          key={key}
          className={classes.filter}
          variant="outlined"
          label="Username"
          name="userId"
          value={userId}
          onUpdate={(name, value) => setUserId(value)}
        />
      </CardContent>
      <Divider />
      <CardActions>
        <Box className={classes.spacer}></Box>
        <Button
          variant="contained"
          color="primary"
          disabled={!userId || loading}
          onClick={resetPassword}
        >
          Reset
        </Button>
      </CardActions>
    </Card>
  );
};

export default ResetPasswordCard;
